const datePattern = "YYYY-MM-DD";
const shortDateDayY = "D MMMM";
const shortDateDayYYYY = "LL";

const textNonRefundableRate =
  " при отмене удерживается полная стоимость проживания.";
const textBookingAmount =
  "(по московскому времени) удерживается стоимость проживания первых суток.";

const textFirstIsRetained =
  "(по московскому времени) удерживается стоимость проживания первых суток.";

const objColorBord = {
  0: "#04B720",
  1: "#FFBD00",
  2: "#FF8A00",
  3: "#DE210B",
};
const colorTextFreeCancellation = {
  0: "#04B720",
  1: "#1F1F1F",
  2: "#DE210B",
};

const fnTextFirstIsRetained = (
  valueWithoutPenaltyShort,
  textFirstIsRetained
) => {
  let textReturn = `С 15:00 ${valueWithoutPenaltyShort} ${textFirstIsRetained}`;
  return textReturn;
};

const fnTextNonRefundableRate = (
  valueWithoutPenaltyShort,
  textNonRefundableRate
) => {
  let textReturn = `С 15:00 ${valueWithoutPenaltyShort} (по московскому времени) ${textNonRefundableRate}`;
  return textReturn;
};

const fnTextBookingAmount = (valueWithoutPenaltyShort, percentPriceValue) => {
  let textReturn = `С 15:00 ${valueWithoutPenaltyShort} (по московскому времени) удерживается сумма в размере ${percentPriceValue} ₽ от стоимости проживания.`;
  return textReturn;
};

const fnTextWithoutPenalty = (valueWithoutPenaltyShort) => {
  let textReturn = `Бесплатная отмена до 15:00 ${valueWithoutPenaltyShort} (по московскому времени).`;
  return textReturn;
};

export {
  datePattern,
  shortDateDayY,
  shortDateDayYYYY,
  textNonRefundableRate,
  textBookingAmount,
  textFirstIsRetained,
  objColorBord,
  colorTextFreeCancellation,
  fnTextFirstIsRetained,
  fnTextNonRefundableRate,
  fnTextBookingAmount,
  fnTextWithoutPenalty,
};
